import React, { PureComponent, FormEvent, ChangeEvent, FocusEvent, KeyboardEvent } from 'react';
import cn from 'classnames';

import styles from './renamer.module.scss';

export type RenamerProps = {
	className?: string;
	value?: string;
	validate?: (nextName: string, prevName?: string) => boolean;
	onSubmit: (fileName: string) => void;
	onAbort: () => void;
};

type RenamerState = {
	renameValue: string;
	isValid: boolean;
};

export class Renamer extends PureComponent<RenamerProps, RenamerState> {
	state = { renameValue: '', isValid: true };
	private _inputRef = React.createRef<HTMLInputElement>();

	static defaultProps = {
		validate: (filename: string) => true,
	};

	handleRenameBlur = (e: FocusEvent<HTMLInputElement>) => {
		const { onSubmit } = this.props;

		if (this.state.isValid) {
			onSubmit && onSubmit(this.state.renameValue);
		} else {
			this.handleAbort();
		}
	};

	handleAbort = () => {
		const { onAbort, value = '' } = this.props;

		this.setState({ renameValue: value }, () => onAbort && onAbort());
	};

	handleValueChanged = (e: ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;

		const isValid = this.props.validate
			? this.props.validate(value, this.props.value)
			: true;

		this.setState({ renameValue: value, isValid });
	};

	handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
		const { key } = e;
		const { isValid, renameValue } = this.state;
		const { onSubmit } = this.props;

		switch (key) {
			case 'Escape':
				return this.handleAbort();
			case 'Enter':
				if (!isValid) return;

				return onSubmit && onSubmit(renameValue);
			default:
				return;
		}
	};

	componentDidMount() {
		const { value = '' } = this.props;
		const promise = new Promise(res => this.setState({ renameValue: value }, res));

		const { _inputRef } = this;

		promise.then(() => {
			const input = _inputRef.current;
			if (!input) return;

			input.focus();

			const dotIdx = value.indexOf('.');
			const end = -1 < dotIdx ? dotIdx : value.length;
			input.setSelectionRange(0, end, 'forward');
		});
	}

	render() {
		const { className } = this.props;
		const { renameValue, isValid } = this.state;

		return (
			<div className={cn(styles.filenameForm, className)}>
				<input
					ref={this._inputRef}
					onBlur={this.handleRenameBlur}
					onKeyDown={this.handleKeyDown}
					className={cn(styles.filenameInput, { [styles.renameInvalid]: !isValid })}
					onChange={this.handleValueChanged}
					value={renameValue}
				/>
			</div>
		);
	}
}
